import { Component } from '@angular/core';
import { ControlItem, RetailerPlanTypeEnum, RetailerTypeEnum, UserRoleEnum } from 'src/app/models/frontend';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RetailersService } from '../retailers.service';
import { CountryService } from '../../countries/country.service';
import { IPagedDiscountTemplateResultRequestDto } from 'src/app/models/backend';
import { DiscountTemplatesService } from '../../discount-templates/discount-templates.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-retailer',
  templateUrl: './create-retailer.component.html',
  styleUrls: ['./create-retailer.component.scss']
})
export class CreateRetailerComponent {
  errors: string[] | null = null;
  eventForm: FormGroup

  isMobileUser: ControlItem[] = []
  isTestAccount: ControlItem[] = []

  retailerType: ControlItem[] = []
  retailerPlanType: ControlItem[] = []

  country:any
  countryList:ControlItem[]=[]
  DiscountTemplates:ControlItem[]=[]
  request: IPagedDiscountTemplateResultRequestDto = {
    isInvoledDeletedItems: false,
    skipCount: 0,
    maxResultCount: 100
  };

  loader=false
  constructor(
    public retailerService: RetailersService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public countryService:CountryService,
    public discountService:DiscountTemplatesService,
    private toastr:ToastrService
  ) {
    this.retailerType = RetailerTypeEnum
    this.retailerPlanType = RetailerPlanTypeEnum
    this.LoadDDLisMobileUser()
    this.LoadDDLisTestAccountr()
    this.LoadCountries()
    this.LoadDiscountTemplates()
  }

  ngOnInit() {
    this.eventForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(100)]],
      lastName: ['', [Validators.required, Validators.maxLength(100)]],
      fullName: ['', [Validators.required, Validators.maxLength(100)]],
      email: ['', [Validators.required, Validators.maxLength(100)]],
      address: ['', [Validators.required, Validators.maxLength(100)]],
      phoneNo: ['', [Validators.required, Validators.maxLength(100)]],
      password: ['', [Validators.required, Validators.maxLength(100)]],
      city: ['', [Validators.required, Validators.maxLength(100)]],
      countryId:[null,Validators.required],
      zipCode: ['', [Validators.required, Validators.maxLength(100)]],
      retailerType: ['', [Validators.required, Validators.maxLength(100)]],
      retailerPlanType: ['', [Validators.required, Validators.maxLength(100)]],
       discountTemplateId:[null,[Validators.required]],
      dailyLimit:[null,[Validators.required]],
      creditLimit:[null,[Validators.required]],
    });
  }
  onSubmit() {
    this.loader=true
    console.log(this.eventForm.value)
    const roleTypeNumber = parseInt(this.eventForm.value.roleType, 10);
    var mobUser = this.eventForm.value.isMobileUser;
    var boolValueMob = (mobUser == this.eventForm.value.isMobileUser);
    var testAccount = this.eventForm.value.isTestAccount;
    var boolValueTest = (testAccount == this.eventForm.value.isMobileUser);

    const countryId = parseInt(this.eventForm.value.countryId, 10);
    const discountId = parseInt(this.eventForm.value.discountTemplateId, 10);
    const retailerTypeNumber = parseInt(this.eventForm.value.retailerType, 10);
    const retailerPlanTypeNumber = parseInt(this.eventForm.value.retailerPlanType, 10);
    const dailyLimitNumber = parseInt(this.eventForm.value.dailyLimit, 10);
    const creditLimitNumber = parseInt(this.eventForm.value.creditLimit, 10);
    if (!this.eventForm.valid) return this.eventForm.markAllAsTouched();

    this.eventForm = this.fb.group({
      firstName: this.eventForm.value.firstName,
      lastName: this.eventForm.value.lastName,
      email: this.eventForm.value.email,
      // code: this.eventForm.value.code,
      fullName: this.eventForm.value.fullName,
      address: this.eventForm.value.address,
      phoneNo: this.eventForm.value.phoneNo,
      password:this.eventForm.value.password,
      city: this.eventForm.value.city,
      countryId:countryId,
      zipCode: this.eventForm.value.zipCode,
      retailerType: retailerTypeNumber,
      retailerPlanType:retailerPlanTypeNumber,
      discountTemplateId:discountId,
      isActive:true,
      dailyLimit:dailyLimitNumber,
      creditLimit:creditLimitNumber,
      isTestMode:false

    })
    console.log(this.eventForm.value)
    this.retailerService.CreateRetailer(this.eventForm.value)
      .subscribe({
        next: r => {
          this.loader=false
          // Swal.fire('Created', '', 'success')
          this.toastr.success('Created','Success')
          
          this.activeModal.close({ refresh: true });
        },
      error:e=>{
        if(e.error?.errors || [e.error?.message])
        {
          this.toastr.error('Oops!', e.error.message);
        }
        else{
          this.toastr.error('Oops!', "Something went wrong");

        }
        this.loader=false
      }
      })
  }

  LoadDDLisMobileUser() {

    this.isMobileUser.push({ label: "Yes", value: true })
    this.isMobileUser.push({ label: "No", value: false })
  }
  LoadDDLisTestAccountr() {

    this.isTestAccount.push({ label: "Yes", value: true })
    this.isTestAccount.push({ label: "No", value: false })
  }
  LoadCountries(){
    this.countryService.GetActiveCountries().subscribe((res:any)=>{
      console.log(res)
      this.country=res
      for(let i=0;i<=this.country.length;i++){
        console.log(this.country[i].categoryName)
        this.countryList.push({label:this.country[i].name,value:this.country[i].id})
      }
    })
  }
  LoadDiscountTemplates(){
    this.discountService.GetDiscountTemplates(this.request).subscribe((res:any)=>{
      console.log(res)
      for(let i=0;i<=res.items.length;i++){
        this.DiscountTemplates.push({label:res.items[i].name,value:res.items[i].id})
      }
    })
  }
}
